module.exports = __webpack_public_path__ + "static/img/favicon.1dabef27.png";